import { useRouter } from 'next/router'

import { InputGroup, Input, InputLeftAddon } from '@wartek-id/input'
import { Icon } from '@wartek-id/icon-v2'

import { usePenetapanPredikatTableStore } from 'app/KinerjaShared/components/PenetapanPredikatTable/Provider'

type SearchProps = {
  className?: string
  placeholder?: string
}

export function Search({
  className,
  placeholder = 'Cari nama Pegawai',
}: SearchProps) {
  const router = useRouter()
  const { nameFilter, setNameFilter } = usePenetapanPredikatTableStore(
    (state) => ({
      nameFilter: state.nameFilter,
      setNameFilter: state.setNameFilter,
    })
  )

  // Handle search input changes
  const handleSearchChange = (value: string) => {
    // Update store
    setNameFilter(value)

    // Update URL
    const query = {
      ...router.query,
    }

    if (value.trim()) {
      query.search = value
    } else {
      delete query.search
    }

    router.replace(
      {
        pathname: router.pathname,
        query,
      },
      undefined,
      { shallow: true }
    )
  }

  return (
    <div className={className}>
      <InputGroup>
        <InputLeftAddon>
          <Icon>search</Icon>
        </InputLeftAddon>
        <Input
          clearable
          placeholder={placeholder}
          className="!pr-12" // Reduce space from the clear button
          value={nameFilter}
          onChange={(e) => handleSearchChange(e.target.value)}
        />
      </InputGroup>
    </div>
  )
}
